var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMistX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.5L5.89746 17.4951C5.39333 17.4438 5 17.0177 5 16.5C5 15.9823 5.39333 15.5562 5.89746 15.5049L6 15.5L21 15.5C21.5523 15.5 22 15.9477 22 16.5C22 17.0523 21.5523 17.5 21 17.5L6 17.5Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5L6.89746 9.50488C6.39333 9.55621 6 9.98232 6 10.5C6 11.0177 6.39333 11.4438 6.89746 11.4951L7 11.5H22C22.5523 11.5 23 11.0523 23 10.5C23 9.94772 22.5523 9.5 22 9.5H7Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5L1.89746 14.4951C1.39333 14.4438 1 14.0177 1 13.5C1 12.9823 1.39333 12.5562 1.89746 12.5049L2 12.5L19 12.5C19.5523 12.5 20 12.9477 20 13.5C20 14.0523 19.5523 14.5 19 14.5L2 14.5Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5L2.89746 8.49512C2.39333 8.44378 2 8.01768 2 7.5C2 6.98232 2.39333 6.55621 2.89746 6.50488L3 6.5L17 6.5C17.5523 6.5 18 6.94772 18 7.5C18 8.05228 17.5523 8.5 17 8.5L3 8.5Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5L17.1025 18.5049C17.6067 18.5562 18 18.9823 18 19.5C18 20.0177 17.6067 20.4438 17.1025 20.4951L17 20.5L8 20.5C7.44772 20.5 7 20.0523 7 19.5C7 18.9477 7.44772 18.5 8 18.5L17 18.5Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.5L16.1025 3.50488C16.6067 3.55621 17 3.98232 17 4.5C17 5.01768 16.6067 5.44379 16.1025 5.49512L16 5.5H9C8.44772 5.5 8 5.05228 8 4.5C8 3.94772 8.44772 3.5 9 3.5H16Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistX2);
export default __webpack_public_path__ + "static/media/MistX2.159c5101bb68590072dcbf3b9bd4a9ca.svg";
export { ForwardRef as ReactComponent };